
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Mumbaitoayodhyacab() {



    const cardData =
    {
        keyword: 'Mumbai to Ayodhya Cab Package',
        heading: 'Skyline Cabs: Mumbai to Ayodhya Cab Package',
        headingDescription: 'Skyline Cabs offers a comfortable and reliable Mumbai to Ayodhya Cab Package for a seamless and spiritual journey. Whether you are traveling for a pilgrimage or leisure, our well-maintained vehicles and professional drivers ensure a smooth and enjoyable ride.​​',

        top: 'Top Places to Visit in prayagraj with Skyline Cabs',

"topPlaces": [
    {
        "title": "Ram Janmabhoomi",
        "description": "Ram Janmabhoomi is the birthplace of Lord Ram and one of the most revered religious sites in Ayodhya. It is considered to be the focal point of the city’s spiritual significance. The temple here is being constructed, attracting pilgrims and tourists alike."
    },
    {
        "title": "Hanuman Garhi",
        "description": "Hanuman Garhi is a prominent temple dedicated to Lord Hanuman, situated on a hilltop. It is one of the most visited temples in Ayodhya and offers a stunning panoramic view of the city. Pilgrims visit here to seek blessings and participate in religious rituals."
    },
    {
        "title": "Kanak Bhawan",
        "description": "Kanak Bhawan is a beautiful temple dedicated to Lord Ram and his consort Sita. Known for its exquisite architecture and serene ambiance, it is one of Ayodhya's most important temples, where devotees offer prayers and seek blessings for prosperity."
    },
    {
        "title": "Tulsi Smarak Bhavan",
        "description": "Tulsi Smarak Bhavan is dedicated to the great poet and saint Tulsidas, who authored the epic Ramcharitmanas. The building houses a museum with artifacts related to Tulsidas and his works, making it a significant stop for literature enthusiasts and devotees of Lord Ram."
    },
    {
        "title": "Saryu River",
        "description": "The Saryu River holds great religious importance in Ayodhya, as it is believed to be the river where Lord Ram performed many rituals. Pilgrims come here to take a holy dip and visit the ghats that line the river, which are associated with the legend of Ram’s life."
    },
    {
        "title": "Dashrath Bhavan",
        "description": "Dashrath Bhavan is the ancient home of King Dashrath, Lord Ram’s father. It is believed to be the place where Lord Ram spent his early years. The site has immense historical and spiritual significance, attracting pilgrims and history buffs alike."
    },
    {
        "title": "Swarg Dwar",
        "description": "Swarg Dwar is believed to be the place where Lord Ram ascended to heaven. It is a sacred site for devotees and a place where people gather to offer prayers for the souls of their ancestors."
    },
    {
        "title": "Choti Devkali Mandir",
        "description": "Choti Devkali Mandir is a revered temple dedicated to Goddess Kali, located on the outskirts of Ayodhya. The temple is known for its spiritual aura and attracts devotees seeking the blessings of the goddess for strength and protection."
    },
    {
        "title": "Ramkot",
        "description": "Ramkot is a historic locality in Ayodhya associated with the birthplace of Lord Ram. It houses the iconic Ram Janmabhoomi temple and several other ancient temples, making it one of the most sacred places in the city for Hindus."
    },
    {
        "title": "Ayodhya Research Institute",
        "description": "The Ayodhya Research Institute is dedicated to the study of the rich history, culture, and heritage of Ayodhya. It offers insights into the spiritual significance of the city and houses various artifacts, manuscripts, and exhibits related to Ayodhya’s ancient past."
    }
],

"services": [
    {
      "name": "Mumbai to Ayodhya Cab",
      "description": "Skyline Cabs offers reliable and comfortable cab services from Mumbai to Ayodhya. Enjoy a long-distance journey with professional drivers and well-maintained vehicles."
    },
    {
      "name": "Ayodhya Cab Package from Mumbai",
      "description": "Plan your spiritual trip with Skyline Cabs’ Ayodhya cab package from Mumbai. Our all-inclusive packages ensure a peaceful and well-organized travel experience."
    },
    {
      "name": "Taxi for Ayodhya Darshan",
      "description": "Book a taxi for Ayodhya darshan with Skyline Cabs. Ideal for pilgrims seeking a smooth and convenient way to visit sacred sites."
    },
    {
      "name": "Mumbai to Ayodhya One Way Cab",
      "description": "Rent a one-way cab from Mumbai to Ayodhya with Skyline Cabs. A hassle-free option for travelers seeking a single journey solution."
    },
    {
      "name": "Ayodhya Tour Taxi Booking",
      "description": "Easily book your Ayodhya tour taxi from Mumbai with Skyline Cabs. Flexible options, comfortable rides, and timely service guaranteed."
    }
  ],
  "tableData": [
    ["Mumbai to Ayodhya Cab", "Ayodhya Cab Package from Mumbai"],
    ["Taxi for Ayodhya Darshan", "Mumbai to Ayodhya One Way Cab"],
    ["Ayodhya Tour Taxi Booking"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Mumbai to Ayodhya Cab Package",
      "WhyChoosedescription": "Embark on a spiritual journey from Mumbai to Ayodhya with our specially curated cab package. Experience comfort, safety, and convenience while visiting the holy city of Shri Ram Janmabhoomi."
    },
    {
      "WhyChooseheading": "Comfortable Long-Distance Travel",
      "WhyChoosedescription": "Our vehicles are well-suited for long intercity travel, offering plush seating, ample luggage space, and a smooth ride all the way to Ayodhya."
    },
    {
      "WhyChooseheading": "Professional and Devoted Drivers",
      "WhyChoosedescription": "Our drivers are experienced in long-haul journeys and well-acquainted with religious routes, ensuring a respectful, safe, and timely ride to Ayodhya."
    },
    {
      "WhyChooseheading": "Affordable Packages with Transparent Pricing",
      "WhyChoosedescription": "We offer all-inclusive, budget-friendly packages with no hidden charges. Get clear pricing and exceptional service for your sacred journey."
    },
    {
      "WhyChooseheading": "Ideal for Pilgrimages and Family Tours",
      "WhyChoosedescription": "Whether you're traveling with family, friends, or on a solo spiritual retreat, our cab packages are tailored for comfortable and meaningful travel."
    },
    {
      "WhyChooseheading": "Clean and Sanitized Vehicles",
      "WhyChoosedescription": "Your safety is our priority. All cabs are regularly cleaned, sanitized, and maintained to high standards for hygiene and performance."
    },
    {
      "WhyChooseheading": "Flexible Travel Plans",
      "WhyChoosedescription": "Choose from one-way, round trip, or multi-day tour packages with the flexibility to include stops at religious or sightseeing destinations en route."
    },
    {
      "WhyChooseheading": "24/7 Support and Easy Booking",
      "WhyChoosedescription": "Book your Mumbai to Ayodhya cab package online or by phone anytime. Our 24/7 customer support team is always ready to help you plan your journey."
    }
  ]
  
  
  
  
  
  
  
  
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Ayodhya cab package with Skyline Cabs?',
            answer:
                'Booking your Ayodhya cab package with Skyline Cabs is simple and convenient. You can book through our website, mobile app, or by calling our customer support. Provide your pickup point in Mumbai, travel dates, and vehicle preference to confirm your booking.',
        },
        {
            id: 2,
            question: 'What is included in the Mumbai to Ayodhya cab package?',
            answer:
                'The Mumbai to Ayodhya cab package includes a round-trip cab from Mumbai, sightseeing in Ayodhya, driver allowance, fuel, tolls, and taxes. The package can be customized to include visits to nearby religious spots like Varanasi, Lucknow, or Kanpur.',
        },
        {
            id: 3,
            question: 'What is the distance and travel time from Mumbai to Ayodhya?',
            answer:
                'The distance from Mumbai to Ayodhya is approximately 1,400 km. The travel time generally ranges from 22 to 26 hours, depending on traffic, road conditions, and any stops you may request along the way.',
        },
        {
            id: 4,
            question: 'What vehicle options are available for the Mumbai to Ayodhya tour?',
            answer:
                'Skyline Cabs offers a variety of vehicles including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups or families, Tempo Travellers and luxury coaches are available.',
        },
        {
            id: 5,
            question: 'Are the entry tickets to temples or places in Ayodhya included in the package?',
            answer:
                'The entry tickets to specific temples or attractions in Ayodhya are not included in the cab package. However, we can assist you with information on how to book tickets at the respective temples.',
        },
        {
            id: 6,
            question: 'Can I customize the itinerary for the Ayodhya trip?',
            answer:
                'Yes, the itinerary is fully customizable. You can request visits to nearby attractions or temples, such as the Ram Janmabhoomi, Hanuman Garhi, or Kanak Bhavan, and we will adjust the schedule accordingly.',
        },
        {
            id: 7,
            question: 'Are overnight stays arranged as part of the tour?',
            answer:
                'Accommodation is not included in the basic cab package, but we can help you arrange hotels in Ayodhya according to your preferences. We offer budget to premium options for overnight stays.',
        },
        {
            id: 8,
            question: 'What payment options are available?',
            answer:
                'We accept payments via UPI, credit/debit cards, net banking, and cash. All online payments are secure and processed through trusted payment gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or reschedule my Mumbai to Ayodhya cab booking?',
            answer:
                'Yes, we offer flexible cancellation and rescheduling policies. You can easily modify or cancel your booking via our website, mobile app, or by calling customer support.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for the Mumbai to Ayodhya trip?',
            answer:
                'Skyline Cabs ensures a safe, comfortable, and affordable journey. With experienced drivers, clean and well-maintained vehicles, transparent pricing, and 24/7 customer support, your journey to Ayodhya will be hassle-free and enjoyable.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rajesh Gupta",
            rating: 5,
            review: "Booked a Mumbai to Ayodhya cab package for our family pilgrimage. The journey was long, but the driver was excellent, and the vehicle was comfortable. We had a smooth experience visiting all the temples in Ayodhya. Highly recommend Skyline Cabs!"
        },
        {
            name: "Mrs. Shweta Patel",
            rating: 4,
            review: "The cab ride to Ayodhya was comfortable, and the driver was very courteous. We had a peaceful journey. Would’ve preferred a little more time at some of the temples, but otherwise a great experience!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



   const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ayodhya Cab Package",
  "image": "https://skylinecabs.com/assets/images/mumbai-to-ayodhya-cab-package.jpg",
  "description": "Book Mumbai to Ayodhya Cab Package with Skyline Cabs for a spiritual and comfortable journey. Travel with verified drivers in AC sedans, SUVs, or luxury cars — perfect for Ram Mandir Darshan and family tours.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8894"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12499",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/mumbai-to-ayodhya-cab-package"
  }
};


      
    
      

    return (
        <div>

<Helmet>
  <title>Mumbai to Ayodhya Cab Package | Ram Mandir Taxi Tour | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Ayodhya Cab Package with Skyline Cabs for a spiritual and comfortable journey. Travel with verified drivers in AC sedans, SUVs, or luxury cars — perfect for Ram Mandir Darshan and family tours." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Ayodhya Cab, Ayodhya Taxi Tour from Mumbai, Ram Mandir Darshan Cab Package, One Way Cab to Ayodhya from Mumbai, AC Cab Mumbai Ayodhya, Skyline Cabs Ayodhya Route, Long Distance Cab Mumbai to Ayodhya, SUV Taxi Ayodhya Tour, Luxury Cab for Ayodhya Trip" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/107.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitoayodhyacab;